module.exports = __webpack_public_path__ + "img/logo.011d69fd.svg";